export const legendButtonsPlugin = {
	id: "legendButtonsPlugin",
	afterUpdate(chart, args, options) {
		const legendContainer = document.getElementById(options.containerID);

		// Remove old legend items
		while (legendContainer.firstChild) {
			legendContainer.firstChild.remove();
		}

		for (let i = 0; i < chart.data.datasets.length; i++) {
			const button = document.createElement("button");
			button.className = "btn btn--primary btn--small";
			button.style.backgroundColor =
				chart.data.datasets[i].backgroundColor[i];
			if (chart.data.datasets[i].label) {
				button.innerText = chart.data.datasets[i].label;
			}
			legendContainer.appendChild(button);
		}
	},
};

export const legendColumnsPlugin = {
	id: "legendColumnsPlugin",
	afterUpdate(chart, args, options) {
		const legendContainer = document.getElementById(options.containerID);
		const list = document.createElement("ul");

		if (!legendContainer) {
			return;
		}

		// Remove old legend items
		while (legendContainer.firstChild) {
			legendContainer.firstChild.remove();
		}

		// Reuse the built-in legendItems generator
		const items = chart.options.plugins.legend.labels.generateLabels(chart);

		items.forEach((item) => {
			const li = document.createElement("li");

			li.onclick = () => {
				chart.setDatasetVisibility(
					item.datasetIndex,
					!chart.isDatasetVisible(item.datasetIndex),
				);
				chart.update();
			};

			// Color box
			const boxSpan = document.createElement("span");
			boxSpan.style.background = item.fillStyle;
			boxSpan.style.borderColor = item.strokeStyle;
			boxSpan.style.borderWidth = item.lineWidth + "px";

			// Text
			const textContainer = document.createElement("p");
			textContainer.style.color = item.fontColor;
			textContainer.style.textDecoration = item.hidden
				? "line-through"
				: "";
			textContainer.innerText = item.text;

			li.appendChild(boxSpan);
			li.appendChild(textContainer);
			list.appendChild(li);
		});

		legendContainer.appendChild(list);
	},
};
